import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TreeNode } from 'primeng/api';
import { ProductUtils } from 'src/app/utils/utils';
import { ProductCategoryItem } from 'src/app/api/models';
import { ProductCategoryService } from 'src/app/api/services';

@Component({
  selector: 'app-product-categories-tree',
  templateUrl: './product-categories-tree.component.html',
  styleUrls: ['./product-categories-tree.component.scss'],
})
export class ProductCategoriesTreeComponent {
  categories?: TreeNode<ProductCategoryItem>[];
  @Input() frmControl?: FormControl;
  @Output() selected = new EventEmitter<ProductCategoryItem>();
  // @Output() cats = new EventEmitter<ProductCategoryItem[]>();

  constructor(private pCategoryService: ProductCategoryService) {}

  ngOnInit() {
    this.pCategoryService.productCategoryControllerGetAll().subscribe(c => {
      this.categories = ProductUtils.catsToTreeNode(c.data.list);
      // this.cats.emit(c.data.list);
    });
  }

  ngAfterViewInit() {
    this.frmControl!.valueChanges.subscribe(v => {
      if (v) {
        this.selected.emit(v.data);
      }
    });
  }

  unselect() {
    this.frmControl!.setValue(null, { emitEvent: true });
  }
}
